import React from 'react';
import { SvgProps } from './icon.types';

function CheckIcon({ ...props }: SvgProps) {
  return (
    <svg viewBox=" 0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.57 5L15 6.43l-7.01 7.01-1.43-1.43L3 8.45l1.43-1.43L8 10.58 13.57 5z"
        fill="#2D3049"
        fillRule="evenodd"
      />
    </svg>
  );
}

export { CheckIcon };
